import React, { useState } from 'react';
import theme from '@/constants/theme';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router';
import { routes } from '@/constants/routes';
import { ChevronRight, LockReset, Logout } from '@mui/icons-material';

const ProfileOptions = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
  };

  const handleChangePassword = () => {
    navigate(routes.changePassword);
  };

  return (
    <div style={styles.container}>
      <p style={styles.title}>Opciones de perfil</p>
      <div style={styles.optionsContainer}>
        <button style={styles.customOptionButton} onClick={handleChangePassword}>
          <LockReset />
          <span>Cambiar contraseña</span>
          <ChevronRight style={styles.chevronRight} />
        </button>
        <button style={styles.customOptionButton} onClick={handleLogout}>
          <Logout />
          Cerrar sesión
          <ChevronRight style={styles.chevronRight} />
        </button>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  title: {
    color: theme.colors.text.default,
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    borderRadius: 8,
    backgroundColor: theme.colors.background.secondary,
    padding: 8,
  },
  customOptionButton: {
    backgroundColor: theme.colors.background.secondary,
    border: 'none',
    color: theme.colors.text.default,
    fontSize: 16,
    cursor: 'pointer',
    padding: 8,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    position: 'relative',
  },
  chevronRight: {
    color: theme.colors.text.caption,
    position: 'absolute',
    right: 0,
  },
};

export default ProfileOptions;